import { render, staticRenderFns } from "./AdvanceSearchCollection.vue?vue&type=template&id=3457b661"
import script from "./AdvanceSearchCollection.vue?vue&type=script&lang=js"
export * from "./AdvanceSearchCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports